/** First letter of the first two words of a display name, e.g. "Ada Lovelace" -> "AL". */
export const initials = (displayName: string) =>
  displayName
    .split(' ')
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
